/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { StockInLocationBulkInsertInner } from './stockInLocationBulkInsertInner';

/**
 * Stores information about Stock (Inventory) items by location including par levels (minimum and maximum desired holdings), quantities on hand and last and average costs.  Quantity and costs information is updated based on stock movement processes like purchases (stock received), sales, discrepencies (wastage, theft etc) , transfers to other locations. 
 */
export interface StockInLocationBulkInsert extends Array<StockInLocationBulkInsertInner> { 
}